import script from "./Data.vue?vue&type=script&setup=true&lang=ts"
export * from "./Data.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/data.css?vue&type=style&index=0&id=1510f490&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1510f490"]])

export default __exports__